"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _dom = _interopRequireDefault(require("./renderer/dom"));

var _reportRenderer = _interopRequireDefault(require("./renderer/report-renderer"));

var _reportUiFeatures = _interopRequireDefault(require("./renderer/report-ui-features"));

var _logger = _interopRequireDefault(require("./renderer/logger"));

var _Template = _interopRequireDefault(require("./Template"));

require("./report-styles.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ReportViewer =
/*#__PURE__*/
function (_Component) {
  _inherits(ReportViewer, _Component);

  function ReportViewer(props) {
    var _this;

    _classCallCheck(this, ReportViewer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReportViewer).call(this, props));
    document.addEventListener("lh-log", function (e) {
      var logger = new _logger["default"](document.querySelector("#lh-log"));

      switch (e.detail.cmd) {
        case "log":
          logger.log(e.detail.msg);
          break;

        case "warn":
          logger.warn(e.detail.msg);
          break;

        case "error":
          logger.error(e.detail.msg);
          break;

        case "hide":
          logger.hide();
          break;

        default:
      }
    });
    return _this;
  }

  _createClass(ReportViewer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.generateReport();
    }
  }, {
    key: "generateReport",
    value: function generateReport() {
      var json = this.props.json;
      var dom = new _dom["default"](document);
      var renderer = new _reportRenderer["default"](dom);
      var container = document.querySelector("main.react-lighthouse-viewer");
      renderer.renderReport(json, container); // Hook in JS features and page-level event listeners after the report
      // is in the document.

      var features = new _reportUiFeatures["default"](dom);
      features.initFeatures(json);
    }
  }, {
    key: "render",
    value: function render() {
      return _react["default"].createElement("div", {
        className: "lh-root lh-vars"
      }, _react["default"].createElement("div", null, _react["default"].createElement(_Template["default"], null)), _react["default"].createElement("main", {
        className: "react-lighthouse-viewer"
      }), _react["default"].createElement("div", {
        id: "lh-log"
      }));
    }
  }]);

  return ReportViewer;
}(_react.Component);

var _default = ReportViewer;
exports["default"] = _default;